import React from 'react';
import { useTranslation } from 'react-i18next';
import { Info } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import { createSx } from '@ui-lib/utils';
import { ebolActionAddPhotoDescriptions } from '../../../const';
import { EBOL_ACTION_REASON_SOURCE } from '../../../types';

const sx = createSx({
  info: {
    backgroundColor: 'info.container',
    borderRadius: 1,
    padding: 2,
  }
});

interface Props {
    status: EBOL_ACTION_REASON_SOURCE;
}

const AddPhotoDescription = ({ status }: Props) => {
  const { t } = useTranslation();

  return (
    <Stack spacing={2} direction={'row'} sx={sx.info}>
      <Info color='primary' />
      <Stack>
        <Typography variant='body2Bold'>
          {t('label_addTruckCargoPhotos')}
        </Typography>
        <Typography variant='body2'>
          {t(ebolActionAddPhotoDescriptions[status])}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default AddPhotoDescription;